module.exports = __webpack_public_path__ + "img/top_reight.7362dc3b.svg";